import { useSubheader } from "../../../../_metronic/layout";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { paymentReducerActions } from "..";

import { Row, Col, Card, Button, Modal, ModalBody, Spinner } from "react-bootstrap";
import { CheckCircle, ReceiptCutoff, InfoCircle, Back } from "react-bootstrap-icons";


const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

const downloadReceipt = (dataStr) => {
  if (dataStr && dataStr.length === 0){
    return;
  }
  const filename = `E-Receipt.pdf`;
  const link = document.createElement("a");
  let data = 'data:application/pdf;base64,' + dataStr;
  link.setAttribute("href", data);
  link.setAttribute("target", "_blank");
  link.setAttribute("rel", "noopener noreferrer");
  link.setAttribute("download", filename);
  link.click();
};

export const PaymentSuccess = (props) => {
  const subheader = useSubheader();
  const dispatch = useDispatch();
  const history = useHistory();

  const { payment, catalogue } = useSelector( (state) => state );

  subheader.setTitle("Payment Successful");

  const { pdfReceiptStr:dataStr, receiptCreatedNum, paymentSuccessful, creatingPayment } = payment;

  const { selectedServiceItem:item } = catalogue;
  
  window.onpopstate = () => {
    dispatch(paymentReducerActions.resetState());
    history.push('/catalogue-management/region');
  };

  useEffect(() => {
    dispatch(paymentReducerActions.resetOrderInfo());
  }, [dispatch]);

  useEffect(() => {
    if(item && Object.keys(item).length === 0){
      history.push('/catalogue-management/region');
    }
  }, [item, history]);
  
  useEffect(() => {
    if(item && Object.keys(item).length === 0){
      history.push('/catalogue-management/region');
    } else {
      if (dataStr && dataStr.length > 0 && paymentSuccessful){
        downloadReceipt(dataStr);
      }
    }
  }, [ dataStr, history, item, paymentSuccessful ]);
  
  

  const redirect = () => {
    history.push('/catalogue-management/region');
  };

  return (
    <Card>
      { creatingPayment ?  
        <Modal show={true} aria-labelledby="contained-modal-title-vcenter" centered >
          <ModalBody className="d-flex align-items-center">
            <Spinner animation="grow" size="lg" variant="warning" /> <span className="pl-5"> Retriving your receipt details... </span>
          </ModalBody>
        </Modal>
        :
        <>
            <Card.Header>
                <Row>
                <Col lg={1} md={12} sm={12} className="d-flex justify-content-center">
                    <CheckCircle size={60} color="green" className="mr-5" />
                </Col>
                <Col lg={11} md={12} sm={12}>
                    <Row> <h5> <b> Your payment was successfully processed! </b> </h5> </Row>
                    <Row> { item.dept_name } - { item.serv_name } </Row>
                    <Row> <span style={{ fontSize: "14px" }} > <b> Receipt No. : { receiptCreatedNum } </b> </span> </Row>
                </Col>
                </Row>
            </Card.Header>


            <Card.Body className="p-5" style={{ fontSize: "14px" }}>
                <div>
                    <p className="text-muted">
                        <InfoCircle size={20} /> Take your receipt to the respectful agency to receive your paid service.
                    </p>
                </div>

                <div>
                    <Col lg={5} md={8} sm={8} className="p-8 ml-5 border border-secondary border-5 rounded">
                        <Row>
                            <Col> <b> Receipt Number: </b> </Col>
                            <Col> { receiptCreatedNum } </Col> 
                        </Row>
                        <Row> 
                            <Col> <b> Department: </b> </Col>
                            <Col> { item.dept_name } </Col> 
                        </Row>
                        <Row>
                            <Col> <b> Province: </b> </Col>
                            <Col> { item.prov_name } </Col> 
                        </Row>
                        <Row> 
                            <Col> <b> Service: </b> </Col>
                            <Col> { item.serv_name } </Col>  
                        </Row>
                        <Row>
                            <Col> <b> Service Description: </b> </Col>
                            <Col> { item.description } </Col> 
                        </Row>
                        <Row>
                            <Col> <b> Total Amount: </b> </Col>
                            <Col> { moneyFormater.format(item.price) } </Col> 
                        </Row>
                    </Col>
                </div>

                <hr/>

                <div className="p-5">
                    <Button onClick={() => {downloadReceipt(dataStr);}} variant="success" className="p5">
                        <ReceiptCutoff size={20} /> {" "}{" "}  Download Receipt 
                    </Button>
                    {" "}{" "}
                    <Button onClick={redirect} variant="info" className="p5" >
                        <Back size={20} /> {" "}{" "}  Service Menu 
                    </Button>
                </div>   
            </Card.Body>
        </>
      }
    </Card>
  );
};
